export default {"src":"/_next/static/media/laboratory-check-up.2f2bc753.svg","height":170,"width":179,"blurWidth":0,"blurHeight":0};